import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
// components
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import Iconify from "../components/iconify";

import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import QuestionsTable from "src/components/pickem-admin/QuestionsTable";
import { usePickems } from "src/hooks/api/usePickems";

// ----------------------------------------------------------------------

const dateFormat = "YYYY-MM-DD HH-mm-ss";
export default function UserSelectionsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pickemId = searchParams.get("pickem_id");
  const userId = searchParams.get("user_id");
  const { fetchPickemById, fetchUserSelections, deletePickemQuestion, updatePickemQuestion } = usePickems();
  const [loading, setLoading] = useState(true);
  const [isScoringMode, setIsScoringMode] = useState(false);
  const [pickemStart, setPickemStart] = useState();
  const [state, setState] = useState({
    title_en: "",
    title_fr: "",
    questions: [],
  });

  useEffect(() => {
    const loadData = async () => {
      if (pickemId && userId) {
        try {
          const pickem = await fetchPickemById(pickemId);
          const selections = await fetchUserSelections(pickemId, userId);
          mergeUserSelections(pickem, selections);
        } catch (error) {
          console.error('Error loading data:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    
    loadData();
  }, [pickemId, userId, fetchPickemById, fetchUserSelections]);

  const mergeUserSelections = (pickem, userSelections) => {
    if (!userSelections || !Array.isArray(userSelections)) {
      setState(pickem);
      return;
    }

    const tiebreaker = userSelections.find(item=>item.option_id===0)
    
    if (pickem.questions && Array.isArray(pickem.questions)) {
      pickem.questions = pickem.questions.map(question => {
        if(question.question_id===tiebreaker?.question_id){
          question.custom_value=tiebreaker.custom_value
          return question
        }
        
        if (question.options && Array.isArray(question.options)) {
          question.options = question.options.map(option => {
            let userQuestionSelections = userSelections.find(selection => selection.question_id === question.question_id);
            if(userQuestionSelections?.custom_value){
              option.custom_value = userQuestionSelections.custom_value
            }
            if (!userQuestionSelections) {
              return option;
            }

            option.isSelected = userQuestionSelections.option_id === option.option_id;

            return option;
          })
        }

        return question;
      });
    }
    setState(pickem);
  }


  const deleteQuestionHandler = async (index) => {
    try {
      await deletePickemQuestion(state.pickem_id, state.questions[index].question_id);
      window.location.reload(false);
    } catch (error) {
      console.error('Error deleting question:', error);
    }
  };

  const optionClickHandler = (questionId, optionId) => {
    if (isScoringMode) {
      let questionIndex = state.questions.findIndex(
        (question) => question.question_id === questionId
      );
      if (questionIndex !== -1) {
        let optionIndex = state.questions[questionIndex].options.findIndex(
          (option) => option.option_id === optionId
        );

        if (optionIndex !== -1) {
          let isCorrect =
            state.questions[questionIndex].options[optionIndex]?.isCorrect &&
            state.questions[questionIndex].options[optionIndex].isCorrect === 1
              ? 0
              : 1;
          state.questions[questionIndex].options[optionIndex].isCorrect =
            isCorrect;
          setState({ ...state });
        }
      }
    }
  };

  const saveScoringQuestions = async () => {
    try {
      const questionUpdatePromises = state.questions.map(question =>
        updatePickemQuestion(state.pickem_id, question.question_id, question)
      );

      await Promise.all(questionUpdatePromises);
      window.location.reload(false);
    } catch (error) {
      console.error('Update questions ERROR:', error);
    }
  };

  return (
    <>
      <Helmet>
        <title> User Selections </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
          User Selections
          </Typography>

          <Box>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:chevron-left-outline" />}
              onClick={() => navigate(`/dashboard/pickem/edit?pickem_id=${pickemId}`)}
              sx={{ mr: 2 }}
            >
              BACK
            </Button>
          </Box>
        </Stack>

        <Card sx={{ padding: 4, marginBottom: 4 }}>
          <Typography variant="h5" sx={{ marginBottom: 2 }}>
            User Selections
          </Typography>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              {state.questions && state.questions.length > 0 ? (
                  <QuestionsTable
                    lang={"en"}
                    questions={state.questions}
                    pickemId={state.pickem_id}
                    deleteQuestionHandler={() => {}}
                    optionClickHandler={() => {}}
                    showActions={false}
                  />
              ) : (
                <Typography>No questions found</Typography>
              )}
            </>
          )}
        </Card>
      </Container>
    </>
  );
}
